import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useContext } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { intentIconMap } from '../intentIconMap';
import Action from '../Action';
import Icon from '../Icon';
import OnDarkContext from '../OnDarkContext';

var toIcon = function toIcon(icon, intent) {
  if (icon === false) {
    return undefined;
  }

  if ((icon === true || !icon) && intent) {
    icon = intentIconMap[intent];
  }

  return Icon.create(icon, intent ? {
    name: intentIconMap[intent]
  } : undefined);
};
/**
 * `Status` component is used for indicating state of an object or the system.
 * @since 0.0.68
 */


var Status = function Status(_ref) {
  var _classNames, _classNames2;

  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "status") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      icon = _ref.icon,
      intent = _ref.intent,
      progress = _ref.progress,
      compact = _ref.compact,
      flip = _ref.flip,
      _ref$outerProps = _ref.outerProps,
      outerProps = _ref$outerProps === void 0 ? {} : _ref$outerProps,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "icon", "intent", "progress", "compact", "flip", "outerProps"]);

  if (intent === 'muted') {
    intent = 'inactive';
  }

  return React.createElement(Action, _extends({
    component: "span",
    icon: compact ? undefined : toIcon(icon, intent),
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--").concat(intent), intent && !progress), _defineProperty(_classNames, "".concat(baseClassName, "--on-dark"), useContext(OnDarkContext)), _classNames), className),
    outerProps: _objectSpread({}, outerProps, {
      className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(baseClassName, "--compact"), compact), _defineProperty(_classNames2, "".concat(baseClassName, "--flip"), flip), _classNames2), outerProps.className)
    }),
    progress: progress
  }, props), children);
};

export default Status;